module.exports = __webpack_public_path__ + "media/hh.f30e72b7.mp4";